<template>
  <div class="bbp-steps-no-data">
    <img class="bbp-steps-no-data__image" :class="{'bbp-steps-no-data__image_large': largeImage}" :src="noData">
    <p class="bbp-steps-no-data__title">No data</p>
    <p>No data, click on the button <b class="bbp-steps-no-data__bold">"{{button}}"</b></p>
    <p>and <b class="bbp-steps-no-data__bold">fill out the form</b>, please</p>
    <button class="bbp-steps-no-data-button" @click.stop="update" v-if="!viewMode">
      <i class="bbp-icon-plus bbp-steps-no-data-button__icon"/>
      <span>{{button}}</span>
    </button>
  </div>
</template>

<script>
import stepsNoData from '@/assets/images/steps-no-data.png'

export default {
  name: 'StepsNoData',
  props: ['viewMode', 'largeImage', 'buttonText'],
  data () {
    return {
      noData: stepsNoData
    }
  },
  computed: {
    button () {
      return this.buttonText || 'Update'
    }
  },
  methods: {
    update () {
      this.$emit('openUpdate')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-steps-no-data {
    @include global-font;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $color-silver;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    text-align: center;

    &__image {
      width: 85px;
      height: auto;
      object-fit: cover;

      &_large {
        width: 150px;
      }
    }

    &__title {
      margin: 10px 0 3px;
      font-weight: bold;
      font-size: 14px;
      line-height: 17px;
    }

    &__bold {
      font-weight: bold;
    }

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 19px;
      padding: 8px 20px;
      color: $color-accent;
      border: 1px dashed $color-accent;
      box-sizing: border-box;
      border-radius: 4px;
      font-weight: 600;
      font-size: 15px;
      line-height: 18px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }

      &__icon {
        font-size: 12px;
        margin-right: 5px;

        &:before {
          margin: 0;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ProjectCard/StepCard/StepsNoData.vue